export const CATEGORIES = {
  ALL: {
    slug: 'all',
    title: 'Tüm Haberler',
    color: '#6B7280',
    url: null // Tüm kategorilerden çekilecek
  },
  GENEL: {
    slug: 'genel-haberler',
    title: 'Genel Haberler',
    color: '#1E40AF',
    url: 'genel-haberler'
  },
  SPOR: {
    slug: 'spor-haberleri',
    title: 'Spor Haberleri',
    color: '#10B981',
    url: 'spor-haberleri'
  },
  TEKNOLOJI: {
    slug: 'teknoloji-haberleri',
    title: 'Teknoloji Haberleri',
    color: '#8B5CF6',
    url: 'teknoloji-haberleri'
  },
  EKONOMI: {
    slug: 'ekonomi-haberleri',
    title: 'Ekonomi Haberleri',
    color: '#F59E0B',
    url: 'ekonomi-haberleri'
  }
};

export const getCategoryBySlug = (slug) => {
  return Object.values(CATEGORIES).find(cat => cat.slug === slug);
};

export const getCategoryTitle = (slug) => {
  const category = getCategoryBySlug(slug);
  return category ? category.title : 'Haberler';
};

export const getCategoryColor = (slug) => {
  const category = getCategoryBySlug(slug);
  return category ? category.color : '#6B7280';
};

export const CATEGORY_LIST = Object.values(CATEGORIES);

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'İnternet bağlantınızı kontrol edin',
  API_ERROR: 'Haberler yüklenirken bir sorun oluştu',
  NO_DATA: 'Bu kategoride henüz haber bulunmuyor',
  TIMEOUT: 'İstek zaman aşımına uğradı, lütfen tekrar deneyin',
  CONFIG_ERROR: 'API ayarları hatalı, lütfen yönetici ile iletişime geçin'
};
